import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2477ba6e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "folder"
}
const _hoisted_2 = { class: "df mt-15 search-wrapper" }
const _hoisted_3 = { class: "w-100" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "javascript:void(0);",
  class: "back-link disabled"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "icon icon-back" })
], -1))
const _hoisted_5 = { class: "df jc-right" }
const _hoisted_6 = {
  href: "javascript:void(0);",
  class: "link select"
}
const _hoisted_7 = { class: "df mt-15 search-wrapper" }
const _hoisted_8 = { class: "w-100" }
const _hoisted_9 = {
  href: "javascript:void(0);",
  class: "back-link disabled"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon icon-back" }, null, -1))
const _hoisted_11 = { class: "df jc-right" }
const _hoisted_12 = {
  href: "javascript:void(0);",
  class: "link select"
}
const _hoisted_13 = {
  key: 1,
  class: "d-folder"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_search = _resolveComponent("app-search")!
  const _component_app_header = _resolveComponent("app-header")!
  const _component_item_mixed = _resolveComponent("item-mixed")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.mainStore.isMobile)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_ctx.mainStore.isMobile)
            ? (_openBlock(), _createBlock(_component_app_header, {
                key: 0,
                customTitle: _ctx.title,
                "count-padding": ""
              }, {
                bottom: _withCtx(() => [
                  _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                      _createVNode(_component_app_search, {
                        disabled: "",
                        placeholder: _ctx.$localize('drive.placeholder.search')
                      }, null, 8, ["placeholder"])
                    ]),
                    _createElementVNode("span", {
                      class: _normalizeClass(["ml-16 icon", _ctx.grid ? 'icon-tiles-2' : 'icon-list-view'])
                    }, null, 2)
                  ])
                ]),
                "top-left": _withCtx(() => [
                  _hoisted_4
                ]),
                "top-right": _withCtx(() => [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("a", _hoisted_6, _toDisplayString(_ctx.$localize('drive.selector')), 1)
                  ])
                ]),
                _: 1
              }, 8, ["customTitle"]))
            : (_openBlock(), _createBlock(_component_app_header, {
                key: 1,
                customTitle: _ctx.title,
                "count-padding": ""
              }, {
                bottom: _withCtx(() => [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _createVNode(_component_app_search, { disabled: "" })
                    ]),
                    _createElementVNode("span", {
                      class: _normalizeClass(["ml-16 icon", _ctx.grid ? 'icon-tiles-2' : 'icon-list-view'])
                    }, null, 2)
                  ])
                ]),
                "top-left": _withCtx(() => [
                  _createElementVNode("a", _hoisted_9, [
                    _hoisted_10,
                    _createTextVNode(" " + _toDisplayString(_ctx.$localize('drive.view.case.backtext')), 1)
                  ])
                ]),
                "top-right": _withCtx(() => [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("a", _hoisted_12, _toDisplayString(_ctx.$localize('drive.selector')), 1)
                  ])
                ]),
                _: 1
              }, 8, ["customTitle"])),
          _createVNode(_component_item_mixed, {
            mixedList: [],
            column: !_ctx.grid,
            skeleton: !_ctx.hideSkeletons
          }, null, 8, ["column", "skeleton"])
        ]))
      : _createCommentVNode("", true),
    (!_ctx.mainStore.isMobile)
      ? (_openBlock(), _createElementBlock("div", _hoisted_13))
      : _createCommentVNode("", true)
  ], 64))
}